module.exports = __webpack_public_path__ + "img/Mode_Selector_SitNGo.b85be3ba.png";